import { ColumnState, ColumnStateParams } from 'ag-grid-community';

export enum DelayOfTableLifecycle {
  set = 500,
  update = 1800,
}

export interface FilterState {
  [filterName: string]: {
    filter?: number;
    filterTo?: number;
    filterType: string;
    type: string;
    values?: (string | number)[];
  };
}

export interface BZColumnState {
  absSorted?: boolean;
  colId: string | undefined;
}

export interface TableParameters {
  bzColumnState: BZColumnState[];
  columns: ColumnState[];
  columnsResized: boolean;
  defaultState?: ColumnStateParams;
  filter: FilterState;
}

export const DefaultTableParameters: TableParameters = {
  bzColumnState: [],
  columns: [],
  columnsResized: false,
  filter: {},
};
